"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _filter = _interopRequireDefault(require("transmute/filter"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _draftConvert = require("draft-convert");

var getCleanList = function getCleanList(dirty) {
  var clean = document.createElement('ul');

  for (var i = 0; i < dirty.childNodes.length; i++) {
    if (dirty.childNodes[i].nodeName === 'LI') {
      (function () {
        // Evernote places their nested ULs inside of other LIs instead of as its own LI,
        // so filter out the actual bullet content, append it as a LI, and then append the UL
        // in its proper place
        var li = document.createElement('li');
        var textNodes = (0, _filter.default)(function (el) {
          return el.nodeName !== 'UL';
        }, dirty.childNodes[i].childNodes);
        var lists = (0, _filter.default)(function (el) {
          return el.nodeName === 'UL';
        }, dirty.childNodes[i].childNodes);
        textNodes.forEach(function (el) {
          return li.appendChild(el.cloneNode(true));
        });
        clean.appendChild(li);
        lists.forEach(function (ul) {
          return clean.appendChild(getCleanList(ul));
        }); // eslint-disable-line no-loop-func
      })();
    }
  }

  return clean;
};

var getCleanNode = function getCleanNode(node) {
  // Evernote was actually pretty easy. They wrap their content in mostly
  // proper HTML, the only exception is lists which they mutate pretty badly
  if (node.textContent) {
    if (node.nodeName === 'UL') {
      return getCleanList(node);
    }

    return node.cloneNode(true);
  }

  return null;
};

var getCleanDocument = function getCleanDocument(dirty) {
  var body = document.createElement('body');

  for (var i = 0; i < dirty.childNodes.length; i++) {
    var newNode = getCleanNode(dirty.childNodes[i]);

    if (newNode) {
      body.appendChild(newNode);
    }
  }

  return body;
};

var _default = function _default(clipboardContent) {
  (0, _invariant.default)(typeof clipboardContent === 'string', "Expected 'clipboardContent' to be a string of HTML, received " + typeof clipboardContent);
  (0, _invariant.default)(clipboardContent.length > 0, 'Expected clipboardContent to have content, received empty string');
  return getCleanDocument((0, _draftConvert.parseHTML)(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
};

exports.default = _default;
module.exports = exports.default;